import { graphql } from 'gatsby';

export { useMenuDefaultFooter } from './menus/use-menu-default-footer';
export { useMenuEnterpriseFooter } from './menus/use-menu-enterprise-footer';
export { useMenuEnterpriseNavbar } from './menus/use-menu-enterprise-navbar';
export { useMenuFooter } from './menus/use-menu-footer';
export { useMenuIntegrationPpcNavbar } from './menus/use-menu-integration-ppc-navbar';
export { useMenuMainNavLinks } from './menus/use-menu-main-nav-links';
export { useMenuSingleMarketoFormPageMe } from './menus/use-menu-single-marketo-form-page-me';
export { useMenuCaseStudyBackButton } from './menus/use-menu-case-study-back-button';
export { useMenuAddons } from './menus/use-menu-addons';

export const query = graphql`
  fragment useMenuHook on Drupal_MenuLinkContent {
    entityUuid
    entityId
    entityBundle
    parent
    link {
      url {
        ...getLinkPath
      }
    }
    entityTranslations {
      entityLanguage {
        id
      }
      ... on Drupal_MenuLinkContent {
        title
      }
      ...useMenuDefaultFooter
      ...useMenuEnterpriseFooter
      ...useMenuEnterpriseNavbar
      ...useMenuFooter
      ...useMenuIntegrationPpcNavbar
      ...useMenuMainNavLinks
      ...useMenuSingleMarketoFormPageMe
      ...useMenuAddons
    }
  }
`;
